var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.breakLine
      ? _c("hr", {
          staticStyle: {
            "flex-basis": "100%",
            height: "0",
            margin: "0",
            border: "0",
          },
        })
      : _vm._e(),
    _vm._v(" "),
    _c("b", [_vm._v(_vm._s(_vm.text))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }